"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.languageDropdownStyles = exports.TabWrapper = exports.StyledLink = exports.StyledInfoContainer = exports.StyledUl = exports.WarningBox = exports.TrainButton = exports.HSLWrapper = exports.buttonStyles = exports.HSLWrapperStyles = exports.StyledOverlayLoader = exports.StyledLoader = exports.StyledText = exports.StyledButton = exports.StyledTextInput = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var loader_1 = __importDefault(require("relements/build/esm/ui/loader"));
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var text_2 = __importDefault(require("relements/build/esm/input/text"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
exports.StyledTextInput = styled_components_1["default"](text_2["default"])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 16px;\n  width: 348px;\n  input {\n    &:hover {\n      border-color: ", ";\n    }\n  }\n"], ["\n  margin-top: 16px;\n  width: 348px;\n  input {\n    &:hover {\n      border-color: ",
    ";\n    }\n  }\n"])), function (props) {
    return props.theme.colors.grey.haptik + " !important";
});
exports.StyledButton = styled_components_1["default"](button_1["default"])(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 37px;\n  width: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  font-size: 14px;\n  &:disabled {\n    background: ", ";\n    color: ", ";\n  }\n"], ["\n  height: 37px;\n  width: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  font-size: 14px;\n  &:disabled {\n    background: ", ";\n    color: ", ";\n  }\n"])), function (props) { return (props.isInProgressButton ? 'fit-content' : '81px'); }, function (props) { return props.theme.colors.grey.haptik; }, function (props) { return props.theme.colors.grey.dark + " !important"; });
exports.StyledText = styled_components_1["default"](text_1["default"])(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n"], ["\n  margin-top: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n"])), function (props) { var _a; return (_a = props.marginTop) !== null && _a !== void 0 ? _a : '16px'; }, function (props) { var _a; return (_a = props.marginBottom) !== null && _a !== void 0 ? _a : '0px'; }, function (props) { var _a; return (_a = props.marginLeft) !== null && _a !== void 0 ? _a : '0px'; });
exports.StyledLoader = styled_components_1["default"](loader_1["default"])(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: fixed;\n  top: 50%;\n  left: 50%;\n"], ["\n  position: fixed;\n  top: 50%;\n  left: 50%;\n"])));
exports.StyledOverlayLoader = styled_components_1["default"](loader_1["default"])(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: absolute;\n  z-index: 111;\n  background: rgba(242, 242, 242, 0.4);\n  height: 100% !important;\n  width: 100% !important;\n  > svg {\n    width: 32px;\n    height: 32px;\n  }\n"], ["\n  position: absolute;\n  z-index: 111;\n  background: rgba(242, 242, 242, 0.4);\n  height: 100% !important;\n  width: 100% !important;\n  > svg {\n    width: 32px;\n    height: 32px;\n  }\n"])));
exports.HSLWrapperStyles = function (props) {
    var theme = props.theme;
    return {
        padding: theme.space.md,
        paddingBottom: 0,
        marginTop: 6,
        borderRadius: theme.radii.sm,
        border: "1px solid " + theme.colors.grey.haptik,
        flexDirection: 'column',
        maxWidth: 364,
    };
};
exports.buttonStyles = function (props) {
    var theme = props.theme, disabled = props.disabled, isGenAi = props.isGenAi;
    return __assign(__assign({ backgroundColor: isGenAi && !disabled && theme.colors.blue.haptik + " !important", marginLeft: '16px', borderRadius: theme.radii.sm, fontFamily: 'Proxima Nova', fontSize: '14px', fontWeight: 600, color: "" + (
        // eslint-disable-next-line no-nested-ternary
        disabled
            ? theme.colors.grey.dark
            : isGenAi
                ? theme.colors.background
                : theme.colors.black.haptik), border: 'none', boxShadow: theme.colors.text + "17 0px 2px 9px", path: {
            // eslint-disable-next-line no-nested-ternary
            fill: disabled
                ? theme.colors.grey.dark
                : isGenAi
                    ? theme.colors.background
                    : theme.colors.black.haptik,
        }, svg: {
            cursor: disabled ? 'not-allowed' : 'pointer',
        } }, (!disabled &&
        !isGenAi && {
        '&:hover': {
            backgroundColor: theme.colors.blue.pastel + " !important",
            color: "" + theme.colors.blue.haptik,
            path: {
                fill: theme.colors.blue.haptik,
            },
        },
    })), { '> div': {
            gap: theme.space.xs,
        } });
};
exports.HSLWrapper = styled_components_1["default"](box_1["default"])(exports.HSLWrapperStyles);
exports.TrainButton = styled_components_1["default"](button_1["default"])(exports.buttonStyles);
var confirmationBoxStyles = function (props) { return ({
    marginTop: 14,
    background: props.theme.colors.yellow.pastel,
    borderColor: props.theme.colors.yellow.dark,
    borderRadius: 4,
}); };
exports.WarningBox = styled_components_1["default"](box_1["default"])(confirmationBoxStyles);
var listStyles = function (props) { return ({
    margin: '0px !important',
    paddingLeft: '20px !important',
    color: props.theme.colors.black.haptik,
    lineHeight: 1.5,
}); };
exports.StyledUl = styled_components_1["default"]('ul')(listStyles);
exports.StyledInfoContainer = styled_components_1["default"](box_1["default"])(function (props) { return ({
    borderRadius: props.theme.radii.sm,
    backgroundColor: props.variant === 'error' ? props.theme.colors.red.pastel : '#ebf9fc',
    border: "1px solid " + (props.variant === 'error'
        ? props.theme.colors.red.haptik
        : props.theme.colors.teal.neon),
    padding: 16,
    marginTop: '16px',
}); });
exports.StyledLink = styled_components_1["default"].a(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  color: ", ";\n  &:hover {\n    color: ", ";\n    text-decoration: underline !important;\n  }\n"], ["\n  color: ", ";\n  &:hover {\n    color: ", ";\n    text-decoration: underline !important;\n  }\n"])), function (props) { return props.theme.colors.text; }, function (props) { return "" + props.theme.colors.blue.haptik; });
var wrapperStyles = function (props) {
    var theme = props.theme;
    return {
        marginTop: theme.space.md + theme.space.xs,
        marginLeft: theme.space.md * 2,
        border: "1px solid " + theme.colors.grey.neon,
        borderRadius: theme.radii.lg,
        width: 'fit-content',
        padding: "0 " + theme.space.md + "px 0 " + theme.space.md + "px",
    };
};
exports.TabWrapper = styled_components_1["default"](box_1["default"])(wrapperStyles);
exports.languageDropdownStyles = {
    maxWidth: 438,
    paddingLeft: '24px',
    paddingRight: '24px',
    marginTop: '12px',
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
